<template>
    <div class="d-flex flex-row flex-column-fluid page">
        <!--begin::Aside-->
        <Aside></Aside>
        <!--end::Aside-->
        <!--begin::Wrapper-->
        <div class="d-flex flex-column flex-row-fluid wrapper pt-0" id="kt_wrapper">
            <!--begin::Content-->
            <div class="content d-flex flex-column flex-column-fluid mt-22 mt-lg-0 pb-0" id="kt_content">
                <!--begin::Entry-->
                <div class="container-fluid mb-4" v-if="errors && Object.keys(errors).length > 0">
                    <div class="alert alert-custom alert-light-danger fade show mb-0 shadow-sm" role="alert">
                        <div class="alert-icon">
                            <i class="fas fa-exclamation-circle"></i>
                        </div>
                        <div class="alert-text">
                            <div v-for="error in errors">{{ error }}</div>
                        </div>
                        <div class="alert-close">
                            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                <span aria-hidden="true"><i class="ki ki-close"></i></span>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="mx-3 px-5 mt-5 flex-grow-1">
                    <FlashMessages/>
                    <div class="d-flex flex-row justify-content-end">
                        <PortalTarget name="toolbar" multiple />
                        <PortalTarget name="modals" multiple />
                    </div>
                    <slot />
                </div>
                <PageFooter />
            </div>
            <!--end::Content-->
        </div>
        <!--end::Wrapper-->
    </div>
</template>

<script>
import Toasts from '../components/Toasts';
import StoreHeader from '../components/Store/StoreHeader.vue';
import {PortalTarget} from 'portal-vue';
import LanguageSelect from '../components/LanguageSelect.vue';
import PageFooter from './Includes/PageFooter.vue';
import FlashMessages from '../components/FlashMessages.vue';
import Aside from '@components/Navigation/Aside.vue'

export default {
    components: {
        Aside,
        FlashMessages,
        PageFooter,
        LanguageSelect,
        StoreHeader,
        Toasts,
        PortalTarget,
    },

    props: {
        auth_uid: String,
        errors: Object,
    },
};
</script>
